module.exports = __webpack_public_path__ + "static/media/img-header-secondary.299f9fb6.png";